// src/components/LoggedOut/ProductList.jsx

import React from "react";
import ProductCard from "./ProductCard";
import LoadingSpinner from "../Shared/LoadingSpinner";
import { Button } from "antd";
import "../../styles/ProductList.css";

function ProductList({
  products = [],
  isLoading = false,
  error = null,
  hasMore = false,
  loadMore = () => {},
  favorites = [],
  handleAddToFavorites = () => {},
}) {
  return (
    <div className="product-list-container">
      {error ? (
        <div className="error-container">
          <p className="error-text">{error}</p>
          <Button
            onClick={() => {
              loadMore(1);
            }}
            type="primary"
          >
            Reintentar
          </Button>
        </div>
      ) : (
        <div>
          <div className="product-list">
            {products.length > 0 ? (
              products.map((product, index) => {
                // Calculamos el mismo uniqueId que en ProductCard
                const uniqueId =
                  product.FIInventario != null
                    ? `${product.FIProducto}-${product.FIInventario}`
                    : `prod-${product.FIProducto}`;


                // Determinamos si este producto está en favorites
                const isFavorite = favorites.some(
                  (fav) => fav.uniqueId === uniqueId
                );

                return (
                  <ProductCard
                    key={uniqueId}
                    product={product}
                    isFavorite={isFavorite}
                    onAddToFavorites={handleAddToFavorites}
                  />
                );
              })
            ) : (
              !isLoading && <p>No hay productos disponibles.</p>
            )}
          </div>

          {isLoading && <LoadingSpinner message="Cargando productos..." />}

          {hasMore && products.length > 0 && !isLoading && (
            <div className="load-more-container">
              <Button
                onClick={loadMore}
                type="primary"
                size="large"
                className="load-more-button"
              >
                Mostrar más productos
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ProductList;
